import { Modal } from 'bootstrap';

export default class ProductDetailPage {
    constructor() {
        console.info('ProductDetailPage.constructor()');

        this.initListeners();
        this.initSlider();
    }

    initListeners() {
        console.info('ProductDetailPage.initListeners()');

        const jsShowNowButton = document.querySelector('.js-show-now');

        if(jsShowNowButton) {
            jsShowNowButton.addEventListener('click', (event) => {
                const modalElement = document.getElementById('modal--shop-now');
                const modal = new Modal(modalElement);
                modal.show();
            });
        }

        // Add event listener for modal close button
        const closeButton = document.querySelector('#modal--shop-now .close');
        if (closeButton) {
            closeButton.addEventListener('click', (event) => {
                const modalElement = document.getElementById('modal--shop-now');
                const modal = Modal.getInstance(modalElement);
                modal.hide();
            });
        }

    }

    initSlider() {
        console.info('ProductDetailPage.initSlider()');

        $('.gallery__image').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.gallery__thumbnails',
            infinite: true,
            adaptiveHeight: true,
        });

        $('.gallery__thumbnails').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.gallery__image',
            centerMode: true,
            focusOnSelect: true,
            arrows: true,
            variableWidth: true,
            infinite: true,
        });

        // On before slide change match active thumbnail to current slide
        $('.gallery__image').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var slideIndex = nextSlide;
            $('.gallery__thumbnails .slick-slide').removeClass('slick-active');
            $('.gallery__thumbnails .slick-slide').eq(slideIndex).addClass('slick-active');
        });
    }
}
